<template>
    <tbody>
    <tr>
        <td><i class="fas fa-grip-vertical"></i></td>
        <td width="15%">
            <p class="form-control" style="width: 142px; height: 42px;" v-if="lineitem && lineitem.goodsSerivces">{{lineitem.goodsSerivces.name}}
                <span v-if="lineitem.goodsSerivces.code">({{lineitem.goodsSerivces.code}})</span> - {{lineitem.goodsSerivces.variety}}
            </p>
<!--            <div class="form-control p-0-0">-->
<!--                <multiselect-->
<!--                        :class="{'is-invalid': submitted && errors.has('goodsservice'+index)}"-->
<!--                        :clear-on-select="false"-->
<!--                        :close-on-select="true"-->
<!--                        :hide-selected="true"-->
<!--                        :id="'goodsservice'+index"-->
<!--                        :internal-search="false"-->
<!--                        :limit="3"-->
<!--                        :loading="isLoading"-->
<!--                        :max-height="600"-->
<!--                        :name="'goodsservice'+index"-->
<!--                        :options="services"-->
<!--                        :options-limit="300"-->
<!--                        :searchable="true"-->
<!--                        :show-no-results="false"-->
<!--                        @input="setGoodsSerivces(selectedGS)"-->
<!--                        @search-change="getGoodsServices"-->
<!--                        data-vv-as="goodsservice"-->
<!--                        label="goodsservice"-->
<!--                        open-direction="bottom"-->
<!--                        placeholder="Search Goods"-->
<!--                        selectLabel=""-->
<!--                        style="width: 142px;"-->
<!--                        track-by="id"-->
<!--                        v-model="selectedGS"-->
<!--                        v-validate="'required'">-->
<!--                    <template slot="singleLabel" slot-scope="props">-->
<!--                        <div class="option__desc">-->
<!--                            <div class="option__desc"-->
<!--                                 style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">-->
<!--                                {{ props.option.commodity_name }} - {{ props.option.variety }}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    <template slot="option" slot-scope="props">-->
<!--                        <div class="option__desc">-->
<!--                            <div class="option__desc" v-if="props.option">-->
<!--                                <h5>{{ props.option.commodity_name }}</h5>-->
<!--                                {{ props.option.variety}}-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </multiselect>-->
<!--                <div class="invalid-feedback" v-if="submitted && errors.has('goodsservice'+index)">{{-->
<!--                    errors.first('goodsservice'+index) }}-->
<!--                </div>-->
<!--            </div>-->
        </td>
        <td width="15%">
            <textarea :name="'description'+index"
                      class="form-control"
                      cols="30"
                      placeholder="Description"
                      style="height: 42px;"
                      v-model="lineitem.description">
            </textarea>
        </td>
        <td>
            <multiselect :class="{'is-invalid': submitted && errors.has('expense_category'+index)}"
                         :group-select="true"
                         :id="'expense_category'+index"
                         :multiple="false"
                         :name="'expense_category'+index"
                         :options="categoryOptions"
                         class="form-control"
                         group-label="group"
                         group-values="accounts"
                         label="name"
                         placeholder="Select Category"
                         track-by="name"
                         v-model="lineitem.expense_category"
                         v-validate="''">
                <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
            </multiselect>
            <div class="invalid-feedback" v-if="submitted && errors.has('expense_category'+index)">{{
                errors.first('expense_category'+index) }}
            </div>
        </td>
        <td width="15%">
            <div class="input-group">
                <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                       :id="'quantity'+index"
                       :name="'quantity'+index"
                       class="form-control"
                       data-vv-as="Name"
                       placeholder="Quantity"
                       style="height: 42px;"
                       type="text"
                       v-model="lineitem.quantity"
                       v-on:keyup="quantityAndRateChange"
                       v-validate="'required'">
                <div class="input-group-append">
                    <span class="input-group-text">{{lineitem.unitSymbol}}</span>
                </div>
                <div class="invalid-feedback" v-if="submitted && errors.has('quantity'+index)">{{
                    errors.first('quantity'+index) }}
                </div>
            </div>
        </td>
        <td width="12%">
            <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                   :id="'rate'+index"
                   :name="'rate'+index"
                   class="form-control"
                   data-vv-as="rate"
                   placeholder="Rate"
                   style="height: 42px;"
                   type="text"
                   v-model="lineitem.rate"
                   v-on:keyup="quantityAndRateChange"
                   v-validate="'required'">
            <div class="invalid-feedback" v-if="submitted && errors.has('rate'+index)">{{
                errors.first('rate'+index) }}
            </div>
        </td>
        <td class="text-right">
            <h5 class="m-b-0" v-if="lineitem.amount">{{lineitem.amount | money}}</h5>
        </td>
        <td class="icon-col">
            <a @click.prevent="removeItem(index)" href="#">
                <i class="far fa-trash-alt text-orange"></i>
            </a>
        </td>
    </tr>

    <!-- Taxes-->

    <tr>
        <td class="tax" colspan="4">
            Tax
        </td>
        <td colspan="2">
            <multiselect :allow-empty="false"
                         :id="'tax'+index"
                         :max-height="300"
                         :options="taxOptions"
                         :options-limit="300"
                         :searchable="true"
                         @input="addTax"
                         class="form-control"
                         deselect-label="Can't remove this value"
                         label="name"
                         open-direction="bottom"
                         placeholder="Select Tax"
                         track-by="rateid"
                         v-model="tax">
                <template slot="singleLabel" slot-scope="props">
                    <span class="option__desc">
                        <span class="option__title">{{ props.option.description }} &nbsp;&nbsp; {{ props.option.rate }}%</span>
                    </span>
                </template>
                <template slot="option" slot-scope="props">
                    <span class="option__title"><b>{{ props.option.name }}</b> &nbsp;&nbsp; {{ props.option.rate }}%</span>
                </template>
            </multiselect>
        </td>
        <td class="text-right">
        </td>
    </tr>

    <tr v-for="(t, tindex) in lineitem.taxes" v-if="lineitem.taxes.length > 0">
        <td class="tax" colspan="4">
        </td>
        <td colspan="2">
            {{t.name}} - {{t.rate}}%
        </td>
        <td class="text-right">
            {{calculateTax(t)}}
        </td>
        <td class="icon-col">
            <a @click.prevent="removeTax(tindex)" href="#">
                <i class="far fa-trash-alt text-orange"></i>
            </a>
        </td>
    </tr>

    </tbody>
</template>

<script>
    import _ from 'lodash';
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import {BigNumber} from "bignumber.js";
    import GoodsServicesSelect from "../../../protected/common/GoodsServicesSelect";

    export default {
        name: "BillLineItem",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),

            amount: function () {
                let amount = new BigNumber(this.lineitem.quantity).multipliedBy(new BigNumber(this.lineitem.rate));
                return amount.isNaN() ? "" : amount.toFormat(2);
            },

            units: function () {
                return this.lineitem.goodsSerivces ? this.lineitem.goodsSerivces.unit_symbol : "";
            }
        },
        created() {
            this.events.$on('bill_line_item:validate', () => {
                this.validate();
            });
        },
        props: {
            lineitem: Object,
            currency: Object,
            index: Number,
            marketplaceid: Number,
            events: Object,
        },
        components: {Multiselect, GoodsServicesSelect},
        data() {
            return {
                submitted: false,
                isLoading: false,
                tax: null,
                category: null,
                taxOptions: [],
                categoryOptions: [],
                services: [],
                selectedGS: null
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await Promise.all([
                    this.getTaxes(),
                    this.getExpenseCategories(),
                    this.autoFill()
                ])
            },
            async autoFill() {
                if (this.lineitem.id) {
                    this.selectedGS = {
                        goodsSerivces: {
                            commodity_id: this.lineitem.id
                        },
                        commodity_name: this.lineitem.name,
                        variety: this.lineitem.variety,
                        commodity_id: this.lineitem.id
                    };
                    this.lineitem.unitSymbol = this.lineitem.quantity ? this.lineitem.quantity.unitSymbol : null;
                    if(this.lineitem.unit){
                        this.lineitem.unitSymbol = this.lineitem.unit.symbol;
                    }
                    this.lineitem.quantity = this.lineitem.quantity ?  this.lineitem.quantity.amount : null;
                }

                let mappedTax = this.lineitem.taxes.map(t => ({
                    ...t,
                    tax: {
                        amount: "-",
                        description: t.description,
                        name: t.name,
                        rate: t.rate,
                        rateid: t.rateid
                    }
                }));
                this.lineitem.taxes = mappedTax;
            },
            validate(e) {
                this.submitted = true;
                this.$validator.validate();
            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/commodities/search", {
                    params: {
                        search: searchText,
                        excludeOld: true
                    }
                });
                this.services = reply.data;
                this.isLoading = false;
            },
            setGoodsSerivces(gs) {
                this.lineitem.goodsSerivces = gs;
                this.lineitem.unitSymbol = gs.unit_symbol;
            },
            async getTaxes() {
                this.isLoading = true;

                let reply = await this.$http.get(`org/${this.currentOrg.id}/taxes`);
                let groups = reply.data;

                _.forEach(groups, group => {
                    _.forEach(group.rates, rate => {
                        let tax = {
                            name: group.name,
                            description: group.description,
                            rateid: rate.id,
                            rate: rate.value
                        };
                        this.taxOptions.push(tax);
                    });
                });

                this.isLoading = false;
            },
            async getExpenseCategories() {
                this.isLoading = true;

                let reply = await this.$http.get(`org/${this.currentOrg.id}/chart_of_account`);
                this.categoryOptions = reply.data;

                this.isLoading = false;
            },
            addTax(tax) {
                this.lineitem.taxes.push({
                    name: tax.name,
                    rate_id: tax.rateid,
                    rate: tax.rate,
                    value: {
                        amount: Number(this.lineitem.amount) * Number(tax.rate) / 100,
                        currency_id: this.currency.id,
                        currency_name: this.currency.name,
                        currency_symbol: this.currency.symbol
                    }
                });
                this.tax = null;
            },
            addCategory(category) {
                this.category = category;
                this.lineitem.expense_category = category;
            },
            quantityAndRateChange() {
                let ini_amount = Number(this.lineitem.rate) * Number(this.lineitem.quantity);
                this.lineitem.amount = {
                    amount: ini_amount,
                    currency_id: this.currency.id,
                    currency_name: this.currency.name,
                    currency_symbol: this.currency.symbol
                };
            },
            removeTax(index) {
                this.lineitem.taxes.splice(index, 1);
            },
            calculateTax(tax) {
                if (!tax || !tax.rate) {
                    return "-";
                }

                let amount = new BigNumber(this.lineitem.quantity)
                    .multipliedBy(new BigNumber(this.lineitem.rate));

                if (amount.isNegative()) {
                    amount = amount.multipliedBy(-1);
                }

                amount = amount.multipliedBy(new BigNumber(tax.rate).div(100));

                if (amount.isNaN()) {
                    return "-";
                }

                tax.value.amount = amount;
                return (this.currency.symbol || "") + " " + amount.toFormat(2);
            },
            removeItem(index) {
                this.events.$emit('bill:removeitem', index);
            },
        }
    }
</script>

<style scoped>
    table th, .table td {
        padding: 1rem;
        vertical-align: top;
        border-top: 0;
    }

    table td {
        text-align: left;
        vertical-align: top;
    }

    table td.tax {
        text-align: right;
        vertical-align: middle;
    }
</style>
